var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4532 6.84309C20.3082 5.74927 19.7799 4.75077 18.971 4.04126C18.162 3.33175 17.1299 2.96178 16.0749 3.00313C15.02 3.04447 14.0173 3.49417 13.2613 4.26501C12.5053 5.03585 12.05 6.07289 11.9836 7.17499C7.6634 9.03875 3.44081 4.40488 3.44081 4.40488C2.2204 12.0642 5.88161 15.5747 5.88161 15.5747C4.22186 17.1704 1 17.1704 1 17.1704C1 17.1704 2.92824 21 11.4711 21C20.0139 21 20.5264 10.7876 20.5264 10.7876C21.3312 10.4813 22.0118 9.89676 22.4557 9.13069C22.8996 8.36463 23.08 7.46299 22.9672 6.57501C22.1441 6.77936 21.2988 6.86949 20.4532 6.84309Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c68cf3a65fd7a25857e6010b059a5c03.svg";
export { ForwardRef as ReactComponent };